var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"teaser-video",on:{"click":_vm.handleVideoClick}},[_c('div',{staticClass:"content"},[_c('video',{ref:"video",attrs:{"poster":_vm.posterframeUrl},on:{"ended":_vm.handleVideoEnded}},[_c('source',{attrs:{"src":_vm.videoUrl,"type":"video/mp4"}})]),(_vm.paused)?_c('div',{staticClass:"button-play"}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }